import React from 'react';
import Svg from 'rp-react-svg-icon';

const ErrorMessage = () => (
    <div
        className="ui-errorMessage"
        key="container"
    >
        <Svg
            iconName="results"
            size="XL"
        />
        <div
            className="ui-errorMessage__text"
            key="errorText"
        >
            No going or non-runner information available in the Racing Post database for this date
        </div>
    </div>
);

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/js/nonRunners/components/ErrorMessage.jsx